import React from "react";
import { Link, TypographyV2 } from "@components";
import { StaticImage } from "gatsby-plugin-image";
import * as styles from "./NavigationFooter.module.scss";
import { LINKS, LinkType } from "@components/Link/Link";

type FooterProps = {
	theme: "light" | "dark";
};

export default function NavigationFooter({ theme }: FooterProps) {
	return (
		<div className={styles.navFooterContainer}>
			<div className={styles.navMenuContainer}>
				<NavMenu theme={theme} title="Products" links={PRODUCT} />
				<NavMenu theme={theme} title="Solutions" links={SOLUTIONS} />
				<NavMenu theme={theme} title="Resources" links={RESOURCES} />
				<div className={styles.lastContainer}>
					<NavMenu theme={theme} title="Company" links={COMPANY} />
					<NavMenu theme={theme} title="Social" links={SOCIAL} />
				</div>
			</div>
		</div>
	);
}

type NavMenuProps = {
	title: string;
	links: Readonly<LinkType[]>;
	theme?: "light" | "dark";
};

function NavMenu({ title, links, theme }: NavMenuProps) {
	const sectionClass =
		title === "Products"
			? styles.productSectionContent
			: title === "Solutions"
			? styles.solutionsSectionContent
			: title === "Resources"
			? styles.resourcesSectionContent
			: title === "Company"
			? styles.companySectionContent
			: title === "Social"
			? styles.socialSectionContent
			: "";

	return (
		<div className={`${styles.menuSection}`}>
			<TypographyV2
				className={`${
					theme === "dark"
						? styles.menuSectionHeaderDark
						: styles.menuSectionHeaderLight
				}`}
			>
				{title}
			</TypographyV2>
			<div className={`${styles.menuSectionContent} ${sectionClass}`}>
				{links.map((link, index) => {
					return (
						<Link key={link + index} link={link}>
							<TypographyV2
								className={`${
									theme === "dark"
										? styles.linkDark
										: styles.linkLight
								}`}
							>
								{LINKS[link].title}
							</TypographyV2>
						</Link>
					);
				})}
			</div>
		</div>
	);
}

const PRODUCT = [
	"INVENTORY",
	"INSIGHTS",
	"CONSUMABLES",
	"LIVE_EDITING",
	"ORDERS",
	"GENEMOD_AI",
	"DASHBOARD",
	"INFORMATION_TECHNOLOGY",
	"NOTEBOOK",
	"INTEGRATIONS",
	"PROTOCOLS",
	"EQUIPMENT",
] as const;

const SOLUTIONS = [
	"BIOPHARMA",
	"CELL_THERAPY",
	"BIOTECH",
	"RNA_THERAPY",
	"RESEARCH",
	"ANTIBODIES",
	"MANUFACTURING",
	"CHEMISTRY",
	"REPOSITORY",
	"STARTUPS",
	"SERVICES",
	"ACADEMIA",
] as const;

const RESOURCES = [
	"VS_EXCEL",
	"VS_QUARTZY",
	"VS_LABARCHIVES",
	"VS_FREEZERPRO",
	"BLOG",
	"CASE_STUDIES",
	"LIMS",
	"ELN",
	"PROFESSIONAL_SERVICES",
	"CONTACT_US"
] as const;

const COMPANY = ["PRICING", "ABOUT_US" ] as const;

const SOCIAL = ["LINKEDIN", "TWITTER"] as const;
